// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.interruption-chart[data-v-3ac6b59c] {\n    height: 100% !important;\n    size: 100% !important;\n}\n", ""]);
// Exports
module.exports = exports;
